<template>
  <crumbs />
  <div class="mainContainer">
    <show-content :detail = 'detail'></show-content>
  </div>
</template>

<script setup>
import TopContent from "../components/topContent";
import {getRLZYDetail} from "../../../apis/rlzy";
import ShowContent from "../../../components/showContent";

const detail = ref({})
const Route = useRoute()

const talentManageId = ref(Route.params.id)
const contentRes = await useAsyncData('getRLZYDetail', () => getRLZYDetail(talentManageId.value))
let data = contentRes.data._value
if (data.code === 200) {
  detail.value = data.data
}
/**
const currentActivePage = ref("")
const talentManageId = ref(null)
currentActivePage.value = Route.query.from
if (currentActivePage.value) {
  let router_typeId = {
    "/rlzy/jypx": 1,
    "/rlzy/xxgk": 2,
    "/rlzy/zpxx": 3,
  }
  talentManageId.value = router_typeId[Route.query.from]
  console.log(Route.query.from)
  if (!talentManageId.value) {
    console.log("访问路径错误1")
    // if (process.client) {
    //   window.location.href = "/rlzy/xxgk"
    // }
  } else {
    const contentRes = await useAsyncData('getRLZYDetail', () => getRLZYDetail(talentManageId.value))
    let data = contentRes.data._value
    if (data.code === 200) {
      detail.value = data.data
    }
  }
} else {
  console.log("访问路径错误2")
  if (process.client) {
    window.location.href = "/rlzy/xxgk"
  }
}
*/

// getRLZYDetail
</script>

<style scoped>

</style>